import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type StepPageHeaderProps = {
  title: TranslationKeys;
  subtitle: TranslationKeys;
  classNames?: {
    wrapper?: string;
  };
};

export const StepPageHeader: FC<StepPageHeaderProps> = ({ title, subtitle, classNames }) => {
  const { t } = useTranslation();
  const titleKey = toRuntimeTranslationKey(title);
  const subtitleKey = toRuntimeTranslationKey(subtitle);

  return (
    <section className={twMerge('flex flex-col border-b border-secondary-border pb-8', classNames?.wrapper)}>
      <h2 className='text-lg font-semibold leading-7 text-primary-900'>{t(titleKey as any)}</h2>
      <h4 className='text-sm leading-5 text-tertiary-600'>{t(subtitleKey as any)}</h4>
    </section>
  );
};
